import * as React from "react"
import { useMemo } from "react"
import { Box, Typography, CircularProgress } from "@mui/material"
import { TableSeeker } from "@ui-seeker/core"

import { tableData, totalCount, isLoadingTable, currentPage, pageSize } from "../@signals"
import { siteColumn, brandColumn, productColumn, productIdColumn, idSiteColumn, idCustomerColumn, eanColumn, referenceColumn, categoryColumn, productUrlColumn, lastSeenColumn, matchesColumn, matchStatusColumn, priceScoreColumn, actionsColumn } from "./columns"


export default function RetailerProductsTable() {
    const data = tableData.value
    const isLoading = isLoadingTable.value

    const columns = useMemo(() => [
        siteColumn(),        // 0
        brandColumn(),       // 1
        productColumn(),     // 2
        productIdColumn(),   // 3
        idSiteColumn(),      // 4
        idCustomerColumn(),  // 5
        eanColumn(),         // 6
        referenceColumn(),   // 7
        categoryColumn(),    // 8
        productUrlColumn(),  // 9
        lastSeenColumn(),    // 10
        matchesColumn(),     // 11
        matchStatusColumn(),  // 12
        priceScoreColumn(),  // 13
        actionsColumn()      // 14
    ], [])

    const tableRows = useMemo(() =>
        data.map(item => ([
            item.site_name,                                     // 0
            item.brand,                                         // 1
            {                                                   // 2 - product object
                name: item.name,
                product_id: item.product_id,
                ean: item.ean,
                reference: item.reference,
                image_url: item.image_url,
                product_url: item.product_url,
                variant_raw: item.variant_raw
            },
            item.product_id,                                    // 3
            item.id_site,                                       // 4
            item.id_customer,                                   // 5
            item.ean,                                           // 6
            item.reference,                                     // 7
            item.category,                                      // 8
            item.product_url,                                   // 9
            item.last_seen,                                     // 10
            item.matches,                                       // 11
            item.matches?.length > 0 ? 'Matched' : 'Unmatched', // 12
            item.price_score,                                   // 13
            null                                                // 14 actions (rendered by column)
        ]))
    , [data])

    // Before first search
    if (!data.length && !isLoading && totalCount.value === 0) {
        return <Box sx={{ textAlign: 'center', py: 8 }}>
            <Typography variant="body1" sx={{ color: '#9ca3af' }}>
                Select a customer and click Search to view products
            </Typography>
        </Box>
    }

    // Loading state
    if (isLoading) {
        return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 8 }}>
            <CircularProgress size={32} sx={{ mr: 2 }} />
            <Typography variant="body1" sx={{ color: '#6b7280' }}>
                Loading products...
            </Typography>
        </Box>
    }

    return <TableSeeker
        title=""
        data={tableRows}
        columns={columns}
        options={{
            filter: false,
            search: false,
            print: false,
            download: false,
            viewColumns: true,
            selectableRows: 'none',
            responsive: 'standard',
            serverSide: true,
            count: totalCount.value,
            page: currentPage.value,
            rowsPerPage: pageSize.value,
            rowsPerPageOptions: [20, 50, 100],
            onChangePage: (page) => currentPage.value = page,
            onChangeRowsPerPage: (size) => { pageSize.value = size; currentPage.value = 0 },
            setRowProps: () => ({ style: { cursor: 'default' } }),
        }}
    />
}
